import TextField from '@mui/material/TextField';
import React, { forwardRef, memo } from 'react';

import { useInputOptions } from './helpers';

import { KColors } from '../../constants';
import { KInputProps } from '../types';

const KTextField = forwardRef<HTMLInputElement, KInputProps>((props, ref) => {
  const {
    combinedRef,
    innerStyle,
    innerProps,
    renderOptions,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    hasFocus,
    ...rest
  } = useInputOptions(props, ref);

  const { children } = props;

  const sx = {
    background: props.disabled ? '#e2e8f0' : KColors.white,
    ...innerProps.sx,
    ...(!innerProps.label && {
      '& legend': { display: 'none' },
      '& fieldset': { top: 0 }
    })
  };

  return (
    // @ts-ignore
    <TextField
      id={innerProps.name}
      size="small"
      variant="outlined"
      {...innerProps}
      style={innerStyle}
      inputRef={combinedRef}
      spellCheck={false}
      autoComplete="off"
      {...rest}
      sx={sx}
    >
      {children || renderOptions}
    </TextField>
  );
});

KTextField.defaultProps = {
  fullWidth: true,
  br: '2x'
};

export default memo(KTextField);
